import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Auth from './auth';

const PrivateRoute = ({ children, requiredRole, redirectPath = '/profile' }) => {
    const location = useLocation();

    useEffect(() => {
        if (!Auth.loggedIn()) {
            Auth.setReferrer(location.pathname);
        }
    }, [location]);

    if (!Auth.loggedIn()) {
        return <Navigate data-testid="navigate" to="/login" />;
    }

    if (requiredRole) {
        const roleChecks = {
            'FMB_ADMIN': Auth.isFmbAdmin(),
            'FEEDBACK_ADMIN': Auth.isFeedbackAdmin(),
            'MIQAAT_ADMIN': Auth.isMiqaatAdmin(),
            'FMB_USER': Auth.isFmbUser()
        };

        if (!roleChecks[requiredRole]) {
            return <Navigate data-testid="navigate" to={redirectPath} />;
        }
    }

    return children;
};

export default PrivateRoute;
